import React from 'react';
import '../styles/Ledger.css';

// Shared "Ledger" building blocks used on Home, Work and case-study pages.

export const StatusBadge = ({ status }) => (
  <span className="status-badge">
    <span className={`status-light tone-${status.tone}`} aria-hidden="true">
      {status.light}
    </span>
    {status.label}
  </span>
);

// Horizontal flow with accent arrows; stacks vertically on narrow screens.
export const Pipeline = ({ steps, featured = false, label }) => (
  <ol className={`pipeline${featured ? ' is-featured' : ''}`} aria-label={label}>
    {steps.map((step, i) => (
      <li key={step}>
        <span className="pipeline-index" aria-hidden="true">
          {String(i + 1).padStart(2, '0')}
        </span>
        <span className="pipeline-step">{step}</span>
      </li>
    ))}
  </ol>
);

// Money flow styled as a ticket stub with a perforated edge.
export const MoneyFlow = ({ steps }) => (
  <div className="ticket-stub">
    <span className="ticket-stub-label">Money flow</span>
    <ol className="ticket-stub-steps">
      {steps.map((step) => (
        <li key={step}>{step}</li>
      ))}
    </ol>
  </div>
);

export const Facts = ({ facts }) => (
  <dl className="facts">
    {facts.map((fact) => (
      <div key={fact.label} className="fact">
        <dt className="label">{fact.label}</dt>
        <dd>{fact.value}</dd>
      </div>
    ))}
  </dl>
);
